import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from '~/core/scripts/components/Icon';

class KandidatenList extends PureComponent {

  renderListItem(item, index) {
    let reps = this.props.data;
    return (
      <tr
        key={`kandidatenlist__item-${reps.names[index]}`}
        className="kandidatenlist__item"
      >
        <td className="kandidatenlist__item-index">
          {index + 1}.
        </td>
        <td className="kandidatenlist__item-name">
          {reps.names[index]}
        </td>
        <td className="kandidatenlist__item-votes">
          {reps.results[index]}
        </td>
        <td className="kandidatenlistt__item-value">
        </td>
      </tr>
    )
  }
  render() {
    return (
      <Fragment>
        {this.props.data.names.map((d, i) => this.renderListItem(d, i))}
      </Fragment>
    );
  }
}

export default KandidatenList;
